import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=9bcc7b12&scoped=true"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=9bcc7b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc7b12",
  null
  
)

export default component.exports